import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("rc_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => localStorage.removeItem("rc_token"))
      .finally(() => setLoading(false));
  }, []);

  const authSet = (data) => {
    localStorage.setItem("rc_token", data.token);
    setUser(data.user);
  };

  const logout = () => {
    localStorage.removeItem("rc_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, authSet, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
